import { Field } from "formik";
import React, { useCallback } from "react";
import AsyncSelect from "react-select/async";
import StarIcon from "../../assets/icons/req-star";
import ErrorMsg from "./error-msg";
import { useDispatch } from "react-redux";
import { debounce } from "lodash";
import { PRODUCT_SEARCH_FIELDS } from "./search-add-field";

const ItemsSearchAddFeild = ({
  placeholder = "Type to search...",
  fetchData,
  name,
  label = "Item Code",
  isLabelReq = true,
  field = "",
  value = { label: "" },
  onChange = () => {},
  isRequired = true,
  errorClass,
  isDisabled = false,
  searchRef,
  values,
  minWidth = "10rem",
  onFocus = () => {},
  dropdown = false,
  menuWidth = "100%",
  optionPadding = 7,
  menuPlacement = "auto",
  defaultOptions = false,
  useDefaultStyles = false,
  allowSpecial = PRODUCT_SEARCH_FIELDS.includes(field),
}) => {
  const dispatch = useDispatch();
  const customStyles = {
    indicatorSeparator: () => ({ display: "none" }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),

    menu: (provided) => ({
      ...provided,
      minWidth: menuWidth,
      zIndex: "9999",
      padding: 0,
    }),
    group: (base) => ({
      ...base,
      paddingTop: 0,
      paddingBottom: 0,
      marginTop: 0,
      marginBottom: 0,
    }),
    groupHeading: (provided) => ({
      ...provided,
      paddingLeft: 0, // Remove padding-left
      paddingRight: 0, // Remove padding-right
      margin: 0,
    }),
    menuList: (provided) => ({
      ...provided,
      padding: 0,

      marginLeft: 0,
      marginRight: 0,
      boxSizing: "border-box",
    }),

    control: (base, state) => ({
      ...base,
      margin: 0,
      fontFamily: "Poppins, sans-serif",
      fontSize: "var(--items-search-input-font-size)",
      fontWeight: "var(--items-search-input-font-weight)",
      borderRadius: "6px",
      width: "100%",
      height: "40px",
      backgroundColor: state.isDisabled
        ? "inherit"
        : "var(--items-search-input-bg)",
      color: "var(--items-search-input-color)",
      borderColor: state.isFocused
        ? "var(--items-search-input-focus)"
        : "var(--items-search-input-border)",
      boxShadow: "none",
    }),

    option: (provided, state) => ({
      ...provided,
      padding: optionPadding,
      color: state.data.color || "#000",
      backgroundColor: state.isSelected
        ? "#e5ecffb2"
        : state.isFocused
        ? "#0000002E"
        : null,
      borderBottom: "1px solid #F5F5F5",
      fontFamily: "Inter, sans-serif",
      zIndex: "999",
      "&:hover": {
        backgroundColor: "#0000002E",
      },
    }),

    placeholder: (defaultStyles) => ({
      ...defaultStyles,
      color: "var(--items-search-place-color)",
      fontFamily: "Inter,sans-serif",
      fontSize: "var(--items-search-place-font-size)",
      fontWeight: "var(--items-search-place-font-weight)",
      opacity: "1",
      position: "absolute",
      whiteSpace: "wrap",
    }),

    singleValue: (base, state) => ({
      ...base,
      fontWeight: "var(--items-search-input-font-weight)",
      fontSize: "var(--items-search-input-font-size)",
      color: state.isDisabled ? "inherit" : "var(--items-search-input-color)",
      width: "100%",
    }),

    multiValue: (base) => ({
      ...base,
      backgroundColor: "#E5ECFF",
    }),

    dropdownIndicator: () => ({ display: dropdown ? "block" : "none" }),
    loadingIndicator: () => ({
      display: "none",
    }),
  };

  const handleKeyDown = (event) => {
    if (allowSpecial) return;
    const validKey = /^[a-zA-Z0-9\s]+$/;
    if (!validKey.test(event.key) && event.key !== "Backspace") {
      event.preventDefault();
    }
  };

  const debouncedFetchData = useCallback(
    debounce((inputValue, callback) => {
      fetchData(inputValue, callback, field, values, dispatch);
    }, 500),
    [fetchData, field, values, dispatch]
  );

  return (
    <>
      <Field name={name}>
        {({ meta }) => {
          return (
            <>
              <div className="flex  w-full flex-col ">
                {isLabelReq && (
                  <label
                    style={{
                      minHeight: "1.2rem",
                      color: "var(--items-search-input-label-color)",
                      // fontSize: "var(--items-search-label-fs)",
                      fontWeight: "var(--items-search-label-font-weight)",
                    }}
                    className="whitespace-no-wrap flex  text-xs"
                  >
                    {label}
                    {/* <StarIcon /> */}
                  </label>
                )}
                <AsyncSelect
                  defaultOptions={defaultOptions}
                  // onKeyDown={(event) => {
                  //   if (event.key === "Enter") {
                  //     event.preventDefault();
                  //     event.stopPropagation();
                  //   }
                  // }}
                  onFocus={onFocus}
                  menuPlacement={menuPlacement} // Force dropdown to open upward
                  ref={(el) => {
                    if (searchRef) searchRef.current = el;
                  }}
                  isDisabled={isDisabled}
                  menuPortalTarget={document.body}
                  // {...(value?.label ? { value: value } : {})}
                  value={value}
                  styles={useDefaultStyles ? defaultstyles : customStyles}
                  cacheOptions={false}
                  loadOptions={debouncedFetchData} // ✅ Use the debounced function
                  // loadOptions={(inputValue, callback) => {
                  //   fetchData(inputValue, callback, field, values, dispatch);
                  // }}
                  placeholder={placeholder}
                  loadingIndicator={false}
                  onChange={onChange}
                  onKeyDown={handleKeyDown} // Restrict special characters on keydown
                />
              </div>
              <div
                style={{
                  height: "1.5rem",
                }}
                className={`text-right w-full fs_12 ${errorClass}`}
              >
                {isRequired && <ErrorMsg name={name} />}
              </div>
            </>
          );
        }}
      </Field>
    </>
  );
};

export default ItemsSearchAddFeild;

export const defaultstyles = {
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),

  indicatorSeparator: () => ({ display: "none" }),
  control: (base, state) => ({
    ...base,
    backgroundColor: "var(--items-search-input-bg)", // Using provided variable
    color: "var(--items-search-input-color)", // Using provided variable
    fontSize: "var(--items-search-input-font-size)", // Using provided variable
    fontWeight: "var(--items-search-input-font-weight)", // Using provided variable
    borderColor: state.isFocused
      ? "var(--items-search-input-focus)" // Using provided variable
      : "var(--items-search-input-border)", // Using provided variable
    boxShadow: "none",
    borderRadius: "6px",
    padding: "0",
    margin: "0",
    minHeight: "40px",
    "&:hover": {
      borderColor: "var(--items-search-input-focus)", // Using provided variable
    },
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "3px 6px",
  }),
  // option: (provided, state) => ({
  //   ...provided,
  //   color: state.data.color
  //     ? state.data.color
  //     : "var(--items-search-input-color)", // Using provided variable
  //   backgroundColor: state.isSelected
  //     ? "#e5ecffb2"
  //     : state.isFocused
  //     ? "#0000002E"
  //     : "transparent",
  //   borderBottom: "1px solid #F5F5F5",
  //   fontFamily: "Inter, sans-serif",
  //   fontSize: "var(--items-search-place-font-size)", // Using provided variable
  //   fontWeight: "var(--items-search-place-font-weight)", // Using provided variable
  //   "&:hover": {
  //     backgroundColor: "#0000002E",
  //   },
  // }),
  option: (provided, state) => ({
    ...provided,
    // padding: 0, // Remove default padding since we handle it in the custom div
    margin: 0,
    // Set colors that will be inherited by child elements
    color: state.isSelected
      ? "#1e40af" // Blue color for selected
      : state.isFocused
      ? "#374151" // Dark gray for focused/hovered
      : "#374151", // Default dark gray
    backgroundColor: state.isSelected
      ? "#e5ecffb2"
      : state.isFocused
      ? "#0000002E"
      : "transparent",
    cursor: "pointer",
    transition: "all 0.15s ease-in-out",
    // Remove border and other default styling
    border: "none",
    // Ensure the hover effect covers the entire option
    "&:hover": {
      backgroundColor: "#f9fafb",
      color: "#374151",
    },
    "&:active": {
      backgroundColor: "#f3f4f6",
    },
  }),

  placeholder: (defaultStyles) => ({
    ...defaultStyles,
    color: "var(--items-search-place-color)", // Using provided variable
    fontFamily: "Inter, sans-serif",
    fontSize: "var(--items-search-place-font-size)", // Using provided variable
    fontWeight: "var(--items-search-place-font-weight)", // Using provided variable
    opacity: "0.9",
  }),
  singleValue: (base) => ({
    ...base,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    color: "var(--items-search-input-color)", // Using provided variable
    fontSize: "var(--items-search-input-font-size)", // Using provided variable
    fontWeight: "var(--items-search-input-font-weight)", // Using provided variable
  }),
  multiValue: (base) => ({
    ...base,
    backgroundColor: "#E5ECFF",
    gap: "5px",
    padding: "0px 6px",
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    padding: "0 5px", // Reduced padding for the icon size
    fontSize: "12px", // Reduce the font size (works with font-based icons)
    transform: "scale(0.8)", // Reduce the size of the icon by 20%
  }),
};
